import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { base_url as base_url_from_axios_config } from "../../utils/AxiosConfig";
import axios from "axios";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import EditIcon from "@mui/icons-material/Edit";
import { Plus } from "lucide-react";
import CloseIcon from "@mui/icons-material/Close";
import BusinessIcon from "@mui/icons-material/Business";
import { FiX } from "react-icons/fi";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import dayjs from "dayjs";

const FleetInformationContent = ({ onChange, duplicateRegNo }) => {
  
  const [formdata, setFormData] = useState({
    ACTIVE: "YES",
  });
  const [isEdit, setIsEdit] = useState(false);
  const [isEditData, setIsEditData] = useState(null);
  const [isRegNoDuplicate, setIsRegNoDuplicate] = useState(false);
  const [isRegNoDuplicateCount, setIsRegNoDuplicateCount] = useState();
  const [enableSave, setEnableSave] = useState(false);

  const [base_url] = useState(base_url_from_axios_config);

  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  const companyCode = storedUserDataArray[0]?.cmpcode || null;

 
  useEffect(() => {
    getDepartmentList();
    getMakeList();
    getModelList();
  }, []);

   const location = useLocation();
   
  useEffect(() => {
    if (location.state?.item) {
      // console.log('info edit :',location.state?.item.REG_NO)
      fetchFleetInfo(location.state?.item.REG_NO);
      setIsEditData(location.state.item);
      // setFormData(location.state.item)
      setIsEdit(true);
    }
  }, [location.state]);

  const fetchFleetInfo = async (regNo) => {
    try {
      const apiURL = `${base_url}/api/CpaysCount/${companyCode}/VEHICLEINFO/${regNo}/-`;
      const response = await axios.get(apiURL);
      const data = response.data[0];
      setFormData(data);

      if (onChange) {
        onChange(data);
      }
    } catch (error) {
      console.error("Error whilefetchFleetInfo!:", error);
    }
  };

  // check duplicate regno
  useEffect(() => {
    if (formdata.REG_NO?.length > 0) {
      if (isEdit) {
        duplicateRegNo(false);
        setIsRegNoDuplicate(false);
      } else {
        regNoDupCheck(formdata.REG_NO);
      }
    } else {
      duplicateRegNo(true); // empty reg no = disable save
    }
  }, [formdata.REG_NO, isEdit]);

  const regNoDupCheck = async (regNo) => {
    try {
      if (!regNo) {
        setIsRegNoDuplicate(false);
        return;
      }

      const apiURL = `${base_url}/api/CpaysCount/${companyCode}/VEHICLECOUNT/${regNo}/-`;
      const response = await axios.get(apiURL);

      const count = response?.data?.[0]?.Column1 ?? 0;

      // console.log("data from regNo dup check:", count);

      setIsRegNoDuplicate(count === 1);
      setIsRegNoDuplicateCount(count);
    } catch (error) {
      console.error("Error while checking duplicate reg no!:", error);
      setIsRegNoDuplicate(false);
    }
  };

  // console.log("Edit Mode:", isEdit);
  // console.log("Edit Data:", isEditData);

  const handleChange = (name, value) => {
    // setFormData((prev) => ({
    //   ...prev,
    //   [name]: value,
    // }));

    // if (onChange) {
    //   onChange({ ...formdata, [name]: value });
    // }

    const updated = { ...formdata, [name]: value };
    setFormData(updated);

    if (onChange) {
      onChange(updated);
    }
  };

  const getDepartmentList = async () => {
    const response = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/DEPARTMENT/-`,
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      setDepartmentListFromAPI(newArray);
    } else {
      console.error("error");
    }
  };

  const statusList = [
    "Active (Live)",
    "Under Maintenance",
    "Rented Out",
    "Hired In",
    "In Legal Custody",
    "In Garage",
    "Transferred",
    "Sold",
    "Idle / Available",
    "Reserved",
    "Accident / Damaged",
    "Under Inspection",
    "Decommissioned",
  ];
  const vehicleTypes = [
    "Car (Sedan)",
    "Hatchback",
    "SUV (Sport Utility Vehicle)",
    "Crossover",
    "Pickup Truck (Light)",
    "Van (Cargo)",
    "Van (Passenger)",
    "Minivan / MPV",
    "Truck (Light Duty)",
    "Truck (Medium Duty)",
    "Truck (Heavy Duty)",
    "Trailer",
    "Semi-Trailer / Tractor Unit",
    "Tanker",
    "Tipper / Dump Truck",
    "Flatbed Truck",
    "Refrigerated Truck (Reefer)",
    "Bus (Coach)",
    "Minibus",
  ];

  // Department

  const initialDepartmentInAction = {
    dept_name: "",
    transaction_id: "ED54A276-A746-4649-B085-43CBBAEB7374", // dummy transaction id
    mode: "ENTRY",
  };

  const initialDepartmentInActionEdit = {
    dept_name: "",
    transaction_id: "",
    mode: "EDIT",
  };

  const [departmentListFromAPI, setDepartmentListFromAPI] = useState(null);
  const [showDepartmentCreationEditPopup, setShowDepartmentCreationEditPopup] =
    useState(false);
  const [departmentNameInInputBoxNew, setDepartmentNameInInputBoxNew] =
    useState(initialDepartmentInAction);
  const [departmentNameInInputBoxEdit, setDepartmentNameInInputBoxEdit] =
    useState(initialDepartmentInActionEdit);

  const editDepartmentAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/EDIT/${companyCode}/DEPARTMENT/${departmentNameInInputBoxEdit.dept_name}/${departmentNameInInputBoxEdit.transaction_id}`;

    axios
      .post(apiUrl)
      .then((res) => {
        getDepartmentList();
        setDepartmentNameInInputBoxEdit(initialDepartmentInActionEdit);
      }, {})
      .catch((err) => {});
  };

  const deleteDepartmentAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/DELETE/${companyCode}/DEPARTMENT/${departmentNameInInputBoxEdit.dept_name}/${departmentNameInInputBoxEdit.transaction_id}`;

    axios
      .post(apiUrl)
      .then((res) => {
        getDepartmentList();
        setDepartmentNameInInputBoxEdit(initialDepartmentInActionEdit);
      }, {})
      .catch((err) => {});
  };

  const newDepartmentAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/ENTRY/${companyCode}/DEPARTMENT/${departmentNameInInputBoxNew.dept_name}/ED54A276-A746-4649-B085-43CBBAEB7374`;

    axios
      .post(apiUrl)
      .then((res) => {
        getDepartmentList();
        setDepartmentNameInInputBoxNew(initialDepartmentInAction);
      }, {})
      .catch((err) => {});
  };

  // MODEL

  const [modelListFromAPI, setModelListFromAPI] = useState(null);

  const getModelList = async () => {
    const response = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/MODEL/-`,
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      setModelListFromAPI(newArray);
    } else {
      console.error("error");
    }
  };

  const initialModelInAction = {
    model_name: "",
    transaction_id: "ED54A276-A746-4649-B085-43CBBAEB7374", // dummy transaction id
    mode: "ENTRY",
  };

  const initialModelInActionEdit = {
    model_name: "",
    transaction_id: "",
    mode: "EDIT",
  };

  const [duplicateRegisterNumber, setDuplicateRegisterNumber] = useState(false);
  const [showModelCreationEditPopup, setShowModelCreationEditPopup] =
    useState(false);
  const [modelNameInInputBoxNew, setModelNameInInputBoxNew] =
    useState(initialModelInAction);
  const [modelNameInInputBoxEdit, setModelNameInInputBoxEdit] = useState(
    initialModelInActionEdit,
  );

  const editModelAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/EDIT/${companyCode}/MODEL/${modelNameInInputBoxEdit.model_name}/${modelNameInInputBoxEdit.transaction_id}`;

    axios
      .post(apiUrl)
      .then((res) => {
        getModelList();
        setModelNameInInputBoxEdit(initialModelInActionEdit);
      }, {})
      .catch((err) => {});
  };

  const deleteModelAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/DELETE/${companyCode}/MODEL/${modelNameInInputBoxEdit.model_name}/${modelNameInInputBoxEdit.transaction_id}`;

    axios
      .post(apiUrl)
      .then((res) => {
        getModelList();
        setModelNameInInputBoxEdit(initialModelInActionEdit);
      }, {})
      .catch((err) => {});
  };

  const newModelAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/ENTRY/${companyCode}/MODEL/${modelNameInInputBoxNew.model_name}/ED54A276-A746-4649-B085-43CBBAEB7374`;

    axios
      .post(apiUrl)
      .then((res) => {
        getModelList();
        setModelNameInInputBoxNew(initialModelInAction);
      }, {})
      .catch((err) => {});
  };

  // MAKE

  const [makeListFromAPI, setMakeListFromAPI] = useState(null);

  const getMakeList = async () => {
    const response = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/MAKE/-`,
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      setMakeListFromAPI(newArray);
    } else {
      console.error("error");
    }
  };

  const initialMakeInAction = {
    make_name: "",
    transaction_id: "ED54A276-A746-4649-B085-43CBBAEB7374", // dummy transaction id
    mode: "ENTRY",
  };

  const initialMakeInActionEdit = {
    make_name: "",
    transaction_id: "",
    mode: "EDIT",
  };

  const [showMakeCreationEditPopup, setShowMakeCreationEditPopup] =
    useState(false);
  const [makeNameInInputBoxNew, setMakeNameInInputBoxNew] =
    useState(initialMakeInAction);
  const [makeNameInInputBoxEdit, setMakeNameInInputBoxEdit] = useState(
    initialMakeInActionEdit,
  );

  const editMakeAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/EDIT/${companyCode}/MAKE/${makeNameInInputBoxEdit.make_name}/${makeNameInInputBoxEdit.transaction_id}`;

    axios
      .post(apiUrl)
      .then((res) => {
        getMakeList();
        setMakeNameInInputBoxEdit(initialMakeInActionEdit);
      }, {})
      .catch((err) => {});
  };

  const deleteMakeAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/DELETE/${companyCode}/MAKE/${makeNameInInputBoxEdit.make_name}/${makeNameInInputBoxEdit.transaction_id}`;

    axios
      .post(apiUrl)
      .then((res) => {
        getMakeList();
        setMakeNameInInputBoxEdit(initialMakeInActionEdit);
      }, {})
      .catch((err) => {});
  };

  const newMakeAPI = () => {
    let apiUrl = `${base_url}/api/MasterReg/ENTRY/${companyCode}/MAKE/${makeNameInInputBoxNew.make_name}/ED54A276-A746-4649-B085-43CBBAEB7374`;

    axios
      .post(apiUrl)
      .then((res) => {
        getMakeList();
        setMakeNameInInputBoxNew(initialMakeInAction);
      }, {})
      .catch((err) => {});
  };

  useEffect(() => {
    const isDisabled = isRegNoDuplicate;
    setDuplicateRegisterNumber(isDisabled);
    duplicateRegNo(isDisabled);
  }, [isRegNoDuplicate, formdata.REG_NO]);


  // useEffect(()=>{
  //   console.log('formdata in fleet info content 1. Initial :',formdata)
  // },[])

  // useEffect(()=>{
  //   console.log('formdata in fleet info content  2. :',formdata)
  // },[formdata])

  return (
    <div>
      <div className="bg-slate-100 p-4 border border-gray-50 rounded-lg grid grid-cols-3 gap-8">
        <div className="">
          <label className="block text-sm font-medium mb-1 flex items-center">
            Registration Number
          </label>

          {/* <input
            className="placeholder-gray-400 w-full px-3 py-2 text-sm   rounded bg-white border border-gray-200  "
            value={isEdit ? isEditData?.REG_NO || "" : createRegNo}
            onChange={(e) => {
              if (isEdit) {
                setIsEditData((prev) => ({ ...prev, REG_NO: e.target.value }));
              } else {
                setCreateRegNo(e.target.value);
              }
            }}
          /> */}

          <input
            className={`placeholder-gray-400 w-full px-3 py-2 text-sm   rounded bg-white  ${duplicateRegisterNumber ? "border outline-red-500" : "border border-gray-200"}`}
            value={formdata?.REG_NO || ""}
            onChange={(e) => handleChange("REG_NO", e.target.value)}
          />
        </div>

        <div className="">
          <label className="block text-sm font-medium mb-1 flex items-center">
            Active
          </label>

          <select
            value={formdata?.ACTIVE || formdata?.Active || "Yes"}
            onChange={(e) => handleChange("ACTIVE", e.target.value)}
            className="placeholder-gray-400 w-full px-3 py-2 text-sm   rounded bg-white border border-gray-200 "
          >
            <option>--Select Option--</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
        </div>
        <div className="">
          <label className="block text-sm font-medium mb-1 flex items-center">
            Status
          </label>

          <select
            value={formdata?.STATUS || ""}
            onChange={(e) => handleChange("STATUS", e.target.value)}
            className="placeholder-gray-400 w-full px-3 py-2 text-sm   rounded bg-white border border-gray-200 "
          >
            <option>--Select Status--</option>

            {statusList?.map((item, index) => (
              <option key={index} value={item}>
                {item}
              </option>
            ))}
          </select>
        </div>
      </div>
      <h3 className="text-[#2663EB] font-semibold mb-2 mt-4">
        Primary Information
      </h3>
      <div className="grid grid-cols-3 gap-8 p-2">
        <div className="">
          <label className="block text-sm font-medium mb-1 flex items-center">
            Type of Vehicle
          </label>

          <select
            value={formdata?.TYPE || ""}
            onChange={(e) => handleChange("TYPE", e.target.value)}
            className="placeholder-gray-400 w-full px-3 py-2 text-sm   rounded bg-[#F9FAFA] border border-gray-200 "
          >
            <option>--Select Type--</option>

            {vehicleTypes?.map((item, index) => (
              <option key={index} value={item}>
                {item}
              </option>
            ))}
          </select>
        </div>
        <div className="">
          <label className="block text-sm font-medium mb-1 flex items-center">
            Registration Owner
          </label>

          <input
            placeholder="Enter Registration Owner ..."
            className="placeholder-gray-400 w-full px-3 py-2 text-sm   rounded bg-[#F9FAFA] border border-gray-200  "
            value={formdata?.REG_OWNER || formdata?.regowner || ""}
            onChange={(e) => handleChange("REG_OWNER", e.target.value)}
          />
        </div>

        <div className="">
          <label className="block text-sm font-medium mb-1 flex items-center">
            Current Custodian
          </label>

          <input
            placeholder="Enter Current Custodian..."
            className="placeholder-gray-400 w-full px-3 py-2 text-sm   rounded bg-[#F9FAFA] border border-gray-200  "
            value={
              formdata?.CURR_CUSTODIAN || formdata?.CURRENT_CUSTODIAN || ""
            }
            onChange={(e) => handleChange("CURR_CUSTODIAN", e.target.value)}
          />
        </div>

        <div className="">
          <label className="block text-sm font-medium mb-1 flex items-center">
            Make
          </label>
          <div className="flex justify-between items-center gap-2">
            {/* <input
              placeholder="Enter Make..."
              className="placeholder-gray-400 w-full px-3 py-2 text-sm   rounded bg-[#F9FAFA] border border-gray-200  "
              value={formdata?.MAKE || ""}
              onChange={(e) => handleChange("MAKE", e.target.value)}
            /> */}

            <select
              className="placeholder-gray-400 w-full px-3 py-2 text-sm   rounded bg-[#F9FAFA] border border-gray-200 "
              value={formdata?.MAKE || ""}
              onChange={(e) => handleChange("MAKE", e.target.value)}
            >
              <option>--Select Make--</option>
              {makeListFromAPI?.map((item, index) => (
                <option value={item.Description} key={index}>
                  {item.Description}
                </option>
              ))}
            </select>
            <button
              type="button"
              onClick={() => setShowMakeCreationEditPopup(true)}
              className="bg-blue-500 hover:bg-blue-700 px-2 py-1 text-white font-semibold rounded-md text-sm"
            >
              Manage
            </button>
          </div>
        </div>

        <div className="">
          <label className="block text-sm font-medium mb-1 flex items-center">
            Model
          </label>
          <div className="flex justify-between items-center gap-2">
            {/* <input
              className="placeholder-gray-400 w-full px-3 py-2 text-sm   rounded bg-[#F9FAFA] border border-gray-200  "
              placeholder="Enter Model..."
              value={formdata?.MODEL || ""}
              onChange={(e) => handleChange("MODEL", e.target.value)}
            /> */}

            <select
              className="placeholder-gray-400 w-full px-3 py-2 text-sm   rounded bg-[#F9FAFA] border border-gray-200 "
              value={formdata?.MODEL || ""}
              onChange={(e) => handleChange("MODEL", e.target.value)}
            >
              <option>--Select Model--</option>
              {modelListFromAPI?.map((item, index) => (
                <option value={item.Description} key={index}>
                  {item.Description}
                </option>
              ))}
            </select>
            <button
              type="button"
              onClick={() => setShowModelCreationEditPopup(true)}
              className="bg-blue-500 hover:bg-blue-700 px-2 py-1 text-white font-semibold rounded-md text-sm"
            >
              Manage
            </button>
          </div>
        </div>

        <div className="">
          <label className="block text-sm font-medium mb-1 flex items-center">
            Branch
          </label>

          <div className="flex justify-between items-center gap-2">
            <select
              className="placeholder-gray-400 w-full px-3 py-2 text-sm   rounded bg-[#F9FAFA] border border-gray-200 "
              value={formdata?.BRANCH || formdata?.DEPARTMENT || ""}
              onChange={(e) => handleChange("BRANCH", e.target.value)}
            >
              <option>--Select Branch--</option>
              {departmentListFromAPI?.map((item, index) => (
                <option value={item.Description} key={index}>
                  {item.Description}
                </option>
              ))}
            </select>

            <button
              type="button"
              onClick={() => setShowDepartmentCreationEditPopup(true)}
              className="bg-blue-500 hover:bg-blue-700 px-2 py-1 text-white font-semibold rounded-md text-sm"
            >
              Manage
            </button>
          </div>
        </div>

        <div className="">
          <label className="block text-sm font-medium mb-1 flex items-center">
            Registration Date
          </label>

          <input
            type="date"
            className="placeholder-gray-400 w-full px-3 py-2 text-sm rounded bg-[#F9FAFA] border border-gray-200"
            value={
              formdata.REG_DATE ||
              (formdata["REGISTRAION ON"]
                ? dayjs(formdata["REGISTRAION ON"]).format("YYYY-MM-DD")
                : "")
            }
            onChange={(e) => handleChange("REG_DATE", e.target.value)}
          />
        </div>

        <div className="">
          <label className="block text-sm font-medium mb-1 flex items-center">
            Engine Number
          </label>

          <input
            placeholder="Enter Engine Number..."
            className="placeholder-gray-400 w-full px-3 py-2 text-sm   rounded bg-[#F9FAFA] border border-gray-200  "
            value={formdata?.ENGINE_NO || formdata["ENGINE NO"] || ""}
            onChange={(e) => handleChange("ENGINE_NO", e.target.value)}
          />
        </div>

        <div className="">
          <label className="block text-sm font-medium mb-1 flex items-center">
            Chasis Number
          </label>

          <input
            placeholder="Enter Chasis Number..."
            className="placeholder-gray-400 w-full px-3 py-2 text-sm   rounded bg-[#F9FAFA] border border-gray-200  "
            value={formdata?.CHASIS_NO || formdata?.CHASSIS || ""}
            onChange={(e) => handleChange("CHASIS_NO", e.target.value)}
          />
        </div>

        <div className="">
          <label className="block text-sm font-medium mb-1 flex items-center">
            Expiration Date
          </label>

          <input
            type="date"
            placeholder="Enter Expiration Date..."
            className="placeholder-gray-400 w-full px-3 py-2 text-sm   rounded bg-[#F9FAFA] border border-gray-200  "
            value={
              formdata?.EXPIRATION_DATE ||
              (formdata?.REG_EXPIRY
                ? dayjs(formdata?.REG_EXPIRY).format("YYYY-MM-DD")
                : "") ||
              ""
            }
            onChange={(e) => handleChange("EXPIRATION_DATE", e.target.value)}
          />
        </div>

        <div className="">
          <label className="block text-sm font-medium mb-1 flex items-center">
            Purchase Amount
          </label>

          <input
            placeholder="Enter Purchase Amount..."
            className="placeholder-gray-400 w-full px-3 py-2 text-sm   rounded bg-[#F9FAFA] border border-gray-200  "
            value={formdata?.PURCH_AMOUNT || formdata?.PURCHASE_AMOUNT || ""}
            onChange={(e) => handleChange("PURCH_AMOUNT", e.target.value)}
          />
        </div>

        <div className="">
          <label className="block text-sm font-medium mb-1 flex items-center">
            Traffic Code no
          </label>

          <input
            placeholder="Enter Traffic Code no..."
            className="placeholder-gray-400 w-full px-3 py-2 text-sm   rounded bg-[#F9FAFA] border border-gray-200  "
            value={formdata?.TRAFFIC_CODE_NO || formdata?.TRAFFICCODE || ""}
            onChange={(e) => handleChange("TRAFFIC_CODE_NO", e.target.value)}
          />
        </div>

        <div className="">
          <label className="block text-sm font-medium mb-1 flex items-center">
            Salik Account no
          </label>

          <input
            placeholder="Enter Salik Account no..."
            className="placeholder-gray-400 w-full px-3 py-2 text-sm   rounded bg-[#F9FAFA] border border-gray-200  "
            value={formdata?.SALIK_ACC_NO || formdata?.SALIK_ACCOUNT || ""}
            onChange={(e) => handleChange("SALIK_ACC_NO", e.target.value)}
          />
        </div>
        <div className="">
          <label className="block text-sm font-medium mb-1 flex items-center">
            Salik PIN
          </label>

          <input
            placeholder="Enter Salik PIN..."
            className="placeholder-gray-400 w-full px-3 py-2 text-sm   rounded bg-[#F9FAFA] border border-gray-200  "
            value={formdata?.SALIK_PIN || formdata?.SalikPin || ""}
            onChange={(e) => handleChange("SALIK_PIN", e.target.value)}
          />
        </div>
      </div>

      {/* fleet info content -------- */}
      {/* Active : "Yes" ***** */} 
      {/* CHASSIS : "87216378123" ***** */}
      {/* CURRENT_CUSTODIAN : "Khader" ***** */}
      {/* CUSTODIAN : "Khader" ******/}
      {/* DEPARTMENT : "HEAD OFFICEE" ***** */}
      {/* Department1 : "HEAD OFFICEE"***** */}
      {/* ENGINE NO : "123876123876" ***** */}
      {/* MAKE : "Toyota"***** */}
      {/* MODEL : "Fortuner" ******/}
      {/* PURCHASE_AMOUNT : "500" *******/}
      {/* REGISTRAION ON : "2026-03-15T00:00:00" ******* */}
      {/* REG_NO : "DXB-M-1111" ********/}
      {/* SalikPin : "8787" ********/}
      {/* SALIK_ACCOUNT : "23123" ****** */}
      {/* TYPE : "Van(Passenger)" ******/}
      {/* STATUS: "Rented Out" *****/}
      {/* REG_EXPIRY : "2026-03-16T00:00:00" *****/}
      {/* TRAFFICCODE : "213123"  *****/}

      {/* ODOMENTER : "87216378123" */}

      {/* insurance --------  */}
      {/* INSURANCE_START : "2026-03-22T00:00:00" */}
      {/* INSURANCE EXPIRY : "2026-03-25T00:00:00" */}
      {/* INS_COMPANY : "company 1" */}
      {/* PREMIUM : "premium" */}
      {/* SERIALNO : "23423423"  */}
      {/* INS_Type : "company 1" pending-------*/}

      {/* notes  */}
      {/* Notes : "" */}

      {/* Department  */}
      {showDepartmentCreationEditPopup && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
          {/* Modal Card */}
          <div className="w-[95%] max-w-xl bg-white rounded-2xl shadow-2xl p-6 max-h-[60vh] overflow-y-auto scrollbar-none">
            {/* Header */}
            <div className="flex items-center justify-between border-b pb-3">
              <h2 className="text-lg font-semibold text-[#2663EB] flex items-center gap-2">
                {/* <BusinessIcon className="text-[#2663EB]" /> */}
                {/* DEPARTMENT MANAGEMENT */}
                BRANCH MANAGEMENT
              </h2>

              <button
                onClick={() => setShowDepartmentCreationEditPopup(false)}
                className="p-2 rounded-full hover:bg-gray-100 transition"
              >
                <CloseIcon />
              </button>
            </div>

            <div className="mt-6 flex flex-col sm:flex-row gap-3 items-start sm:items-center">
              <input
                value={departmentNameInInputBoxNew.dept_name}
                type="text"
                placeholder="Enter new branch name here..."
                className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#2663EB]/30 focus:border-[#2663EB] transition"
                onChange={(e) =>
                  setDepartmentNameInInputBoxNew((prev) => ({
                    ...prev,
                    dept_name: e.target.value,
                  }))
                }
              />

              <button
                type="button"
                onClick={newDepartmentAPI}
                className="
    inline-flex items-center gap-2
    bg-blue-500
    text-white
    w-1/2
    px-2 py-1
    text-sm font-semibold
    rounded-md
    shadow-lg
    hover:from-blue-700 hover:to-blue-600
    active:scale-95
    transition-all duration-200
    focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2
  "
              >
                <Plus size={16} />
                {/* Add Department */}
                Add Branch
              </button>
            </div>

            {/* Branch List */}
            <div className="mt-6 space-y-3">
              {departmentListFromAPI?.map((item) => {
                const isEditing =
                  departmentNameInInputBoxEdit.transaction_id
                    ?.trim()
                    ?.toLowerCase() === item.TranId?.trim()?.toLowerCase();

                return (
                  <div
                    key={item.TranId}
                    className="border border-gray-200 rounded-xl px-2 py-1 hover:shadow-md transition"
                  >
                    {/* Row Header */}
                    <div className="flex items-center justify-between">
                      <span className="font-medium text-gray-700">
                        {item.Description}
                      </span>

                      <button
                        type="button"
                        onClick={() =>
                          setDepartmentNameInInputBoxEdit({
                            dept_name: item.Description,
                            transaction_id: item.TranId,
                          })
                        }
                        className="p-2 rounded-md hover:bg-gray-100 transition"
                      >
                        <EditIcon fontSize="small" className="text-gray-600" />
                      </button>
                    </div>

                    {/* Edit Section */}
                    {isEditing && (
                      <div className="mt-4 flex flex-col sm:flex-row gap-3">
                        <input
                          type="text"
                          value={departmentNameInInputBoxEdit.dept_name}
                          onChange={(e) =>
                            setDepartmentNameInInputBoxEdit((prev) => ({
                              ...prev,
                              dept_name: e.target.value,
                            }))
                          }
                          className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#2663EB]/30 focus:border-[#2663EB] transition"
                        />

                        <div className="flex gap-2">
                          <button
                            type="button"
                            onClick={() =>
                              setDepartmentNameInInputBoxEdit(
                                initialDepartmentInActionEdit,
                              )
                            }
                            className="flex items-center gap-1 px-3 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100 transition"
                          >
                            <CancelIcon fontSize="small" />
                            Cancel
                          </button>

                          <button
                            type="button"
                            onClick={editDepartmentAPI}
                            className="flex items-center gap-1 bg-green-600 text-white px-3 py-2 rounded-lg hover:bg-green-700 transition"
                          >
                            <SaveIcon fontSize="small" />
                            Save
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
      {showModelCreationEditPopup && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
          {/* Modal Card */}
          <div className="w-[95%] max-w-xl bg-white rounded-2xl shadow-2xl p-6 max-h-[60vh] overflow-y-auto scrollbar-none">
            {/* Header */}
            <div className="flex items-center justify-between border-b pb-3">
              <h2 className="text-lg font-semibold text-[#2663EB] flex items-center gap-2">
                {/* <BusinessIcon className="text-[#2663EB]" /> */}
                MODEL MANAGEMENT
              </h2>

              <button
                onClick={() => setShowModelCreationEditPopup(false)}
                className="p-2 rounded-full hover:bg-gray-100 transition"
              >
                <CloseIcon />
              </button>
            </div>

            <div className="mt-6 flex flex-col sm:flex-row gap-3 items-start sm:items-center">
              <input
                value={modelNameInInputBoxNew.model_name}
                type="text"
                placeholder="Enter new Model here..."
                className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#2663EB]/30 focus:border-[#2663EB] transition"
                onChange={(e) =>
                  setModelNameInInputBoxNew((prev) => ({
                    ...prev,
                    model_name: e.target.value,
                  }))
                }
              />

              <button
                type="button"
                onClick={newModelAPI}
                className="
    inline-flex items-center gap-2
    bg-blue-500
    text-white
    w-1/2
    px-2 py-1
    text-sm font-semibold
    rounded-md
    shadow-lg
    hover:from-blue-700 hover:to-blue-600
    active:scale-95
    transition-all duration-200
    focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2
  "
              >
                <Plus size={16} />
                Add Make
              </button>
            </div>

            {/* Branch List */}
            <div className="mt-6 space-y-3">
              {modelListFromAPI?.map((item) => {
                const isEditing =
                  modelNameInInputBoxEdit.transaction_id
                    ?.trim()
                    ?.toLowerCase() === item.TranId?.trim()?.toLowerCase();

                return (
                  <div
                    key={item.TranId}
                    className="border border-gray-200 rounded-xl px-2 py-1 hover:shadow-md transition"
                  >
                    {/* Row Header */}
                    <div className="flex items-center justify-between">
                      <span className="font-medium text-gray-700">
                        {item.Description}
                      </span>

                      <button
                        type="button"
                        onClick={() =>
                          setModelNameInInputBoxEdit({
                            model_name: item.Description,
                            transaction_id: item.TranId,
                          })
                        }
                        className="p-2 rounded-md hover:bg-gray-100 transition"
                      >
                        <EditIcon fontSize="small" className="text-gray-600" />
                      </button>
                    </div>

                    {/* Edit Section */}
                    {isEditing && (
                      <div className="mt-4 flex flex-col sm:flex-row gap-3">
                        <input
                          type="text"
                          value={modelNameInInputBoxEdit.model_name}
                          onChange={(e) =>
                            setModelNameInInputBoxEdit((prev) => ({
                              ...prev,
                              model_name: e.target.value,
                            }))
                          }
                          className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#2663EB]/30 focus:border-[#2663EB] transition"
                        />

                        <div className="flex gap-2">
                          <button
                            type="button"
                            onClick={() =>
                              setModelNameInInputBoxEdit(
                                initialModelInActionEdit,
                              )
                            }
                            className="flex items-center gap-1 px-3 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100 transition"
                          >
                            <CancelIcon fontSize="small" />
                            Cancel
                          </button>

                          <button
                            type="button"
                            onClick={editModelAPI}
                            className="flex items-center gap-1 bg-green-600 text-white px-3 py-2 rounded-lg hover:bg-green-700 transition"
                          >
                            <SaveIcon fontSize="small" />
                            Save
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
      {showMakeCreationEditPopup && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
          {/* Modal Card */}
          <div className="w-[95%] max-w-xl bg-white rounded-2xl shadow-2xl p-6 max-h-[60vh] overflow-y-auto scrollbar-none">
            {/* Header */}
            <div className="flex items-center justify-between border-b pb-3">
              <h2 className="text-lg font-semibold text-[#2663EB] flex items-center gap-2">
                {/* <BusinessIcon className="text-[#2663EB]" /> */}
                MAKE MANAGEMENT
              </h2>

              <button
                onClick={() => setShowMakeCreationEditPopup(false)}
                className="p-2 rounded-full hover:bg-gray-100 transition"
              >
                <CloseIcon />
              </button>
            </div>

            <div className="mt-6 flex flex-col sm:flex-row gap-3 items-start sm:items-center">
              <input
                value={makeNameInInputBoxNew.make_name}
                type="text"
                placeholder="Enter new Make here..."
                className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#2663EB]/30 focus:border-[#2663EB] transition"
                onChange={(e) =>
                  setMakeNameInInputBoxNew((prev) => ({
                    ...prev,
                    make_name: e.target.value,
                  }))
                }
              />

              <button
                type="button"
                onClick={newMakeAPI}
                className="
    inline-flex items-center gap-2
    bg-blue-500
    text-white
    w-1/2
    px-2 py-1
    text-sm font-semibold
    rounded-md
    shadow-lg
    hover:from-blue-700 hover:to-blue-600
    active:scale-95
    transition-all duration-200
    focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2
  "
              >
                <Plus size={16} />
                Add Make
              </button>
            </div>

            {/* Branch List */}
            <div className="mt-6 space-y-3">
              {makeListFromAPI?.map((item) => {
                const isEditing =
                  makeNameInInputBoxEdit.transaction_id
                    ?.trim()
                    ?.toLowerCase() === item.TranId?.trim()?.toLowerCase();

                return (
                  <div
                    key={item.TranId}
                    className="border border-gray-200 rounded-xl px-2 py-1 hover:shadow-md transition"
                  >
                    {/* Row Header */}
                    <div className="flex items-center justify-between">
                      <span className="font-medium text-gray-700">
                        {item.Description}
                      </span>

                      <button
                        type="button"
                        onClick={() =>
                          setMakeNameInInputBoxEdit({
                            make_name: item.Description,
                            transaction_id: item.TranId,
                          })
                        }
                        className="p-2 rounded-md hover:bg-gray-100 transition"
                      >
                        <EditIcon fontSize="small" className="text-gray-600" />
                      </button>
                    </div>

                    {/* Edit Section */}
                    {isEditing && (
                      <div className="mt-4 flex flex-col sm:flex-row gap-3">
                        <input
                          type="text"
                          value={makeNameInInputBoxEdit.make_name}
                          onChange={(e) =>
                            setMakeNameInInputBoxEdit((prev) => ({
                              ...prev,
                              make_name: e.target.value,
                            }))
                          }
                          className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#2663EB]/30 focus:border-[#2663EB] transition"
                        />

                        <div className="flex gap-2">
                          <button
                            type="button"
                            onClick={() =>
                              setMakeNameInInputBoxEdit(initialMakeInActionEdit)
                            }
                            className="flex items-center gap-1 px-3 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100 transition"
                          >
                            <CancelIcon fontSize="small" />
                            Cancel
                          </button>

                          <button
                            type="button"
                            onClick={editMakeAPI}
                            className="flex items-center gap-1 bg-green-600 text-white px-3 py-2 rounded-lg hover:bg-green-700 transition"
                          >
                            <SaveIcon fontSize="small" />
                            Save
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FleetInformationContent;
